import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { HeaderBarComponent } from './header-bar/header-bar.component'
import { FooterBarComponent } from './footer-bar/footer-bar.component'
import { NextTenComponent } from '../components/betting/next-ten/next-ten.component'
import { TranslateModule } from '@ngx-translate/core';
import { RaceDetailsComponent } from '../components/betting/race-details/race-details.component';
import { SportDetailsComponent } from '../components/betting/sport-details/sport-details.component'
import { CommonModule } from '@angular/common';
import { AllRacingComponent } from '../components/betting/all-racing/all-racing.component'
import { SportsComponent } from '../components/betting/sports/sports.component'
import { InPlayComponent } from '../components/betting/in-play/in-play.component'
import { ResultDetailsComponent } from '../components/betting/result-details/result-details.component';
import { VirtualComponent } from '../components/betting/vertual/virtual/virtual.component';
import { KironComponent } from '../components/betting/vertual/kiron/kiron.component';
import { TrackSideComponent } from '../components/betting/vertual/track-side/track-side.component'
import { NextTenOddsComponent } from '../components/betting/next-ten/next-ten-odds/next-ten-odds.component';
import { AllRacingOddsComponent } from '../components/betting/all-racing/all-racing-odds/all-racing-odds.component';
import { SportsOddsComponent } from '../components/betting/sports/sports-odds/sports-odds.component';
import { InPlayOddsComponent } from '../components/betting/in-play/in-play-odds/in-play-odds.component';
import { NewsInfoComponent } from '../modals/news-info/news-info.component';
import { RegistrationComponent } from '../modals/registration/registration.component';
import { LoginComponent } from '../modals/login/login.component';
import { BetSlipModalComponent } from '../modals/bet-slip-modal/bet-slip-modal.component';
import { BetSelectionComponent } from '../modals/bet-selection/bet-selection.component';
import { BetSlipProceedModalComponent } from '../modals/bet-slip-proceed-modal/bet-slip-proceed-modal.component';
import { FormsModule,ReactiveFormsModule  } from '@angular/forms';
import { TermsAndConditionsComponent } from '../modals/terms-and-conditions/terms-and-conditions.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import {PdfViewerComponent} from '../modals/pdf-viewer/pdf-viewer.component';
import { NewsReadmoreInfoComponent } from '../modals/news-readmore-info/news-readmore-info.component';
import {EventInfoComponent} from '../modals/event-info/event-info.component';
import {SelectionInfoComponent} from'../modals/selection-info/selection-info.component';
import {ResetPasswordComponent} from '../modals/reset-password/reset-password.component'
import { KironPlayerComponent } from './alert/kiron-player/kiron-player.component';
import { PlayerModalComponent } from './alert/player-modal/player-modal.component';
import { NovaComponent } from './betting/vertual/nova/nova.component';
import { MyslipResultsComponent } from '../modals/myslip-results/myslip-results.component';
import { TranslateSportsPipe } from '../pipes/translate-sports.pipe';
import { TranslateSportsPipeModule } from '../pipes/translate-sport-pipe.module';
import { LuckyHorseComponent } from './betting/vertual/lucky-horse/lucky-horse.component';
import { CricketSuperOverComponent } from './betting/vertual/cricket-super-over/cricket-super-over.component';
import { MainSliderComponent } from './main-slider/main-slider.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { RacingRouletteComponent } from './betting/vertual/racing-roulette/racing-roulette.component';
import { KenoComponent } from './betting/vertual/keno/keno.component';
import { LuckyLootComponent } from './betting/vertual/lucky-loot/lucky-loot.component';
import { ImageZoomViewerComponent } from '../modals/image-zoom-viewer/image-zoom-viewer.component';

@NgModule({
    declarations: [HeaderBarComponent, FooterBarComponent, NextTenComponent,
        RaceDetailsComponent, AllRacingComponent, SportsComponent, InPlayComponent, 
        VirtualComponent, ResultDetailsComponent, KironComponent, 
        TrackSideComponent,NextTenOddsComponent,AllRacingOddsComponent,SportsOddsComponent,
        InPlayOddsComponent,NewsInfoComponent, RegistrationComponent, LoginComponent, BetSlipModalComponent,
        PdfViewerComponent, SportDetailsComponent,EventInfoComponent,
        BetSlipProceedModalComponent,TermsAndConditionsComponent, NewsReadmoreInfoComponent,BetSelectionComponent,SelectionInfoComponent
    ,ResetPasswordComponent,KironPlayerComponent,PlayerModalComponent,HeaderBarComponent
    ,NovaComponent,MyslipResultsComponent,LuckyHorseComponent,CricketSuperOverComponent,MainSliderComponent,RacingRouletteComponent,KenoComponent, LuckyLootComponent, ImageZoomViewerComponent],

    exports: [HeaderBarComponent, FooterBarComponent, NextTenComponent,
        RaceDetailsComponent, AllRacingComponent, SportsComponent, InPlayComponent, 
        VirtualComponent, ResultDetailsComponent, KironComponent, 
        TrackSideComponent,NextTenOddsComponent,AllRacingOddsComponent,SportsOddsComponent,
        InPlayOddsComponent,NewsInfoComponent, RegistrationComponent ,LoginComponent, BetSlipModalComponent,
        PdfViewerComponent, SportDetailsComponent,EventInfoComponent,
        BetSlipProceedModalComponent,TermsAndConditionsComponent, NewsReadmoreInfoComponent,BetSelectionComponent,SelectionInfoComponent
    ,ResetPasswordComponent,KironPlayerComponent,PlayerModalComponent,HeaderBarComponent
    ,NovaComponent,MyslipResultsComponent,LuckyHorseComponent,CricketSuperOverComponent,MainSliderComponent,RacingRouletteComponent,KenoComponent,ImageZoomViewerComponent],

    imports: [ IonicModule, TranslateModule, CommonModule,FormsModule,ReactiveFormsModule,NgxExtendedPdfViewerModule,
        TranslateSportsPipeModule,CarouselModule,],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: []

})

export class ComponentsModule { }